import focus from './FocusManagement';

function init() {
  const menuOpen = document.getElementById('headerMenu__openButton');
  menuOpen && menuOpen.addEventListener('click', e => toggleMenu(true));

  const menuClose = document.getElementById('headerMenu__closeButton');
  menuClose && menuClose.addEventListener('click', e => toggleMenu(false));
}

function toggleMenu(isOpen) {
  const bodyCl = document.body.classList;
  bodyCl.toggle('body--headerNavOpen', isOpen);
  
  document.querySelectorAll('.header__menuWrapWrap').forEach(wrap => {
    wrap.setAttribute('aria-hidden', !isOpen);
    wrap.tabIndex = -1;
    
    if (isOpen) {
      const focusAnchor = wrap.querySelector(".header__menuFocusAnchor");
      focus.enableFocusTrap(wrap, focusAnchor);
    }
    else {
      focus.disableFocusTrap(wrap);
    }
    
    isOpen ? (focus.onEsc(closeMenu)) : (focus.offEsc(closeMenu));
  });
}

function closeMenu() { toggleMenu(false); }

export default { init };